// mockData.js
// ─────────────────────────────────────────────────────────────
// Single source of truth for all mock data.
// Field names match exactly what the API will return.
// Replace with real API calls (services/dynamicPriceApi.js) when ready.
// ─────────────────────────────────────────────────────────────

export const RECOMMENDATIONS = [
  {
    id: 1, type_name: "Standard", checkin_date: "2026-03-01",
    base_rate_single: 2000, recommended_price: 3200, final_price: null,
    confidence_score: 91, status: "PENDING", source_channel: "PMS",
    plan_code: "WALK_IN", rate_fallback: false,
    is_holiday: true, holiday_name: "Holi",
    local_events: "IPL Match — CSK vs MI", occupancy_rate: 88,
    competitor_avg_price: 3500,
    reasoning: "High occupancy (88%) combined with Holi holiday and IPL match creates exceptional demand. Competitor avg ₹3,500 confirms market supports premium pricing.",
    factors: ["Occupancy 88%", "Holi Holiday", "IPL Match"],
  },
  {
    id: 2, type_name: "Deluxe", checkin_date: "2026-03-01",
    base_rate_single: 3500, recommended_price: 5800, final_price: null,
    confidence_score: 94, status: "PENDING", source_channel: "PMS",
    plan_code: "WALK_IN", rate_fallback: false,
    is_holiday: true, holiday_name: "Holi",
    local_events: "IPL Match — CSK vs MI", occupancy_rate: 88,
    competitor_avg_price: 5500,
    reasoning: "Peak demand justifies 65.7% premium over base rate. Competitor avg ₹5,500 fully supports this position.",
    factors: ["Peak Occupancy", "Holiday + Event", "Competitor ₹5,500"],
  },
  {
    id: 3, type_name: "Suite", checkin_date: "2026-03-01",
    base_rate_single: 6000, recommended_price: 9500, final_price: null,
    confidence_score: 89, status: "PENDING", source_channel: "PMS",
    plan_code: "WALK_IN", rate_fallback: false,
    is_holiday: true, holiday_name: "Holi",
    local_events: "IPL Match — CSK vs MI", occupancy_rate: 88,
    competitor_avg_price: 9000,
    reasoning: "Suite premium fully warranted during Holi + IPL confluence. 58.3% above base with competitor headroom intact.",
    factors: ["Holiday + IPL", "High Demand", "Competitor ₹9,000"],
  },
  {
    id: 4, type_name: "Standard", checkin_date: "2026-03-01",
    base_rate_single: 1800, recommended_price: 2900, final_price: null,
    confidence_score: 88, status: "PENDING", source_channel: "BE",
    plan_code: "DIRECT", rate_fallback: false,
    is_holiday: true, holiday_name: "Holi",
    local_events: "IPL Match — CSK vs MI", occupancy_rate: 88,
    competitor_avg_price: 3500,
    reasoning: "Booking Engine rate set 9.4% below PMS to incentivise direct bookings while fully capturing holiday demand premium.",
    factors: ["Direct Channel Incentive", "Holi", "High Demand"],
  },
  {
    id: 5, type_name: "Deluxe", checkin_date: "2026-03-01",
    base_rate_single: 3200, recommended_price: 5300, final_price: null,
    confidence_score: 86, status: "PENDING", source_channel: "BE",
    plan_code: "DIRECT", rate_fallback: false,
    is_holiday: true, holiday_name: "Holi",
    local_events: "IPL Match — CSK vs MI", occupancy_rate: 88,
    competitor_avg_price: 5500,
    reasoning: "Direct booking incentive maintained. 65.6% uplift with BE channel priced below OTA to maximise net revenue.",
    factors: ["Direct Incentive", "Holiday", "High Demand"],
  },
  {
    id: 6, type_name: "Standard", checkin_date: "2026-03-01",
    base_rate_single: 2300, recommended_price: 3800, final_price: null,
    confidence_score: 90, status: "PENDING", source_channel: "OTA",
    plan_code: "OTA_STD", rate_fallback: false,
    is_holiday: true, holiday_name: "Holi",
    local_events: "IPL Match — CSK vs MI", occupancy_rate: 88,
    competitor_avg_price: 3500,
    reasoning: "OTA gross price includes 15% commission recovery. Net to hotel = ₹3,230 — above PMS base rate.",
    factors: ["Commission Recovery", "Peak Demand", "Holi"],
  },
  {
    id: 7, type_name: "Standard", checkin_date: "2026-03-15",
    base_rate_single: 2000, recommended_price: 3500, final_price: 3500,
    confidence_score: 88, status: "APPROVED", source_channel: "PMS",
    plan_code: "WALK_IN", rate_fallback: false,
    is_holiday: true, holiday_name: "Ugadi",
    local_events: "Music Festival", occupancy_rate: 95,
    competitor_avg_price: 4000,
    reasoning: "Ugadi + Music Festival at 95% occupancy. AI recommendation approved at full price — competitor at ₹4,000 leaves headroom.",
    factors: ["Ugadi Holiday", "Music Festival", "95% Occupancy"],
  },
  {
    id: 8, type_name: "Deluxe", checkin_date: "2026-03-15",
    base_rate_single: 3500, recommended_price: 6200, final_price: 5900,
    confidence_score: 86, status: "MODIFIED", source_channel: "PMS",
    plan_code: "WALK_IN", rate_fallback: false,
    is_holiday: true, holiday_name: "Ugadi",
    local_events: "Music Festival", occupancy_rate: 95,
    competitor_avg_price: 6500,
    reasoning: "Manager adjusted ₹300 below AI recommendation based on local market knowledge. Still 68.6% above base.",
    factors: ["Ugadi", "Music Festival", "High Demand"],
  },
  {
    id: 9, type_name: "Suite", checkin_date: "2026-03-15",
    base_rate_single: 6000, recommended_price: 11000, final_price: null,
    confidence_score: 72, status: "REJECTED", source_channel: "PMS",
    plan_code: "WALK_IN", rate_fallback: false,
    is_holiday: true, holiday_name: "Ugadi",
    local_events: "Music Festival", occupancy_rate: 95,
    competitor_avg_price: 10000,
    reasoning: "83.3% uplift felt too aggressive. Manager retained base-adjacent price for this date.",
    factors: ["Ugadi", "Music Festival", "Competitor ₹10,000"],
  },
  {
    id: 10, type_name: "Standard", checkin_date: "2026-04-10",
    base_rate_single: 2000, recommended_price: 2600, final_price: null,
    confidence_score: 80, status: "PENDING", source_channel: "BE",
    plan_code: "DIRECT", rate_fallback: true,
    is_holiday: false, holiday_name: null,
    local_events: "Tech Conference — Chandigarh IT Summit", occupancy_rate: 72,
    competitor_avg_price: 2800,
    reasoning: "Tech conference drives corporate travel demand. Master rate fallback used as no BE-specific rate configured for this type.",
    factors: ["Tech Conference", "72% Occupancy", "Master Rate Fallback"],
  },
  {
    id: 11, type_name: "Deluxe", checkin_date: "2026-04-10",
    base_rate_single: 3500, recommended_price: 4800, final_price: null,
    confidence_score: 85, status: "PENDING", source_channel: "OTA",
    plan_code: "OTA_STD", rate_fallback: false,
    is_holiday: false, holiday_name: null,
    local_events: "Tech Conference — Chandigarh IT Summit", occupancy_rate: 72,
    competitor_avg_price: 5000,
    reasoning: "Business travellers prefer Deluxe. Strong demand from conference bookings with competitor headroom at ₹5,000.",
    factors: ["Tech Conference", "Business Demand", "Competitor ₹5,000"],
  },
  {
    id: 12, type_name: "Suite", checkin_date: "2026-04-10",
    base_rate_single: 6000, recommended_price: 7500, final_price: null,
    confidence_score: 77, status: "PENDING", source_channel: "PMS",
    plan_code: "WALK_IN", rate_fallback: false,
    is_holiday: false, holiday_name: null,
    local_events: "Tech Conference — Chandigarh IT Summit", occupancy_rate: 72,
    competitor_avg_price: 8000,
    reasoning: "Suite demand moderate during conference — controlled 25% premium keeps us well below competitor ₹8,000.",
    factors: ["Tech Conference", "Moderate Demand", "Competitor ₹8,000"],
  },
];

export const COMPETITORS = [
  {
    id: 1, name: "Taj Chandigarh", platform: "MakeMyTrip",
    city: "Chandigarh",
    url: "https://www.makemytrip.com/hotels/taj_chandigarh-details-chandigarh.html",
    status: "active", last_scraped: "2026-02-24 06:00 AM",
    prices: { Standard: 9960, Deluxe: 14500, Suite: 28000 },
  },
  {
    id: 2, name: "Hyatt Regency", platform: "Booking.com",
    city: "Chandigarh",
    url: "https://www.booking.com/hotel/in/hyatt-regency-chandigarh.html",
    status: "active", last_scraped: "2026-02-24 06:00 AM",
    prices: { Standard: 8200, Deluxe: 12000, Suite: 22000 },
  },
  {
    id: 3, name: "JW Marriott", platform: "MakeMyTrip",
    city: "Chandigarh",
    url: "https://www.makemytrip.com/hotels/jw_marriott-details-chandigarh.html",
    status: "error", last_scraped: "2026-02-23 06:00 AM",
    prices: { Standard: 11000, Deluxe: 16000, Suite: 32000 },
  },
  {
    id: 4, name: "Radisson Blu", platform: "Goibibo",
    city: "Chandigarh",
    url: "https://www.goibibo.com/hotels/radisson-blu-hotel-chandigarh-panchkula/",
    status: "inactive", last_scraped: "2026-02-20 06:00 AM",
    prices: { Standard: 6500, Deluxe: 9800, Suite: 18000 },
  },
];

// FIXED: by_source now uses "source" field consistently
export const MONTHLY_REPORT = {
  month: "February 2026",
  total_generated: 360, approved: 210, modified: 98, rejected: 52,
  base_revenue: 4860000, ai_revenue: 6124800,
  uplift_amount: 1264800, uplift_pct: 26.0,
  top_dates: [
    { date: "2026-03-01", event: "Holi + IPL",       uplift: 142000 },
    { date: "2026-03-15", event: "Ugadi + Festival",  uplift: 98000  },
    { date: "2026-04-10", event: "Tech Conference",   uplift: 61000  },
  ],
  // "source" field — consistent with SourceBar spread usage
  by_source: [
    { source: "PMS", generated: 120, approved: 72, uplift_pct: 24.2 },
    { source: "BE",  generated: 120, approved: 68, uplift_pct: 22.8 },
    { source: "OTA", generated: 120, approved: 70, uplift_pct: 31.4 },
  ],
  by_room: [
    { type: "Standard", avg_uplift_pct: 18.4, total_uplift: 380000 },
    { type: "Deluxe",   avg_uplift_pct: 27.6, total_uplift: 548000 },
    { type: "Suite",    avg_uplift_pct: 34.2, total_uplift: 336800 },
  ],
};

export const OCC_TREND = [
  { d: "Feb 24", v: 45 }, { d: "Feb 25", v: 52 }, { d: "Feb 26", v: 48 },
  { d: "Feb 27", v: 61 }, { d: "Feb 28", v: 74 }, { d: "Mar 1",  v: 88 },
  { d: "Mar 2",  v: 91 }, { d: "Mar 3",  v: 67 }, { d: "Mar 4",  v: 55 },
  { d: "Mar 5",  v: 49 }, { d: "Mar 6",  v: 58 }, { d: "Mar 7",  v: 72 },
];

export const SETTINGS_DEFAULT = {
  hotel_name: "The Grand Chandigarh", city: "Chandigarh", currency: "INR",
  auto_approve: false, cron_enabled: true, cron_time: "06:00", days_ahead: 30,
  sources: ["PMS", "BE", "OTA"],
  markup_rules: {
    occupancy_high: { threshold: 80, markup_pct: 20  },
    occupancy_low:  { threshold: 40, markdown_pct: 15 },
    holiday:        { markup_pct: 15 },
    event:          { markup_pct: 25 },
    days_until_3:   { markup_pct: 10 },
  },
  channel_commissions: { PMS: 0, BE: 0, OTA: 15 },
};

export const CRON_HISTORY = [
  { time: "Today 06:00 AM",     ok: true,  recs: 36, duration: "42s"  },
  { time: "Yesterday 06:00 AM", ok: true,  recs: 36, duration: "38s"  },
  { time: "Feb 22 06:00 AM",    ok: true,  recs: 36, duration: "41s"  },
  { time: "Feb 21 06:00 AM",    ok: false, recs: 0,  duration: "—"    },
];

// External room types (from 3rd-party PMS after /setup call)
export const EXTERNAL_ROOM_TYPES_MOCK = [
  { external_id: "RT001", name: "Superior Room",      max_occupancy: 2, saved_mapping: null },
  { external_id: "RT002", name: "Deluxe King",        max_occupancy: 2, saved_mapping: null },
  { external_id: "RT003", name: "Deluxe Twin",        max_occupancy: 2, saved_mapping: null },
  { external_id: "RT004", name: "Junior Suite",       max_occupancy: 3, saved_mapping: null },
  { external_id: "RT005", name: "Executive Suite",    max_occupancy: 3, saved_mapping: null },
  { external_id: "RT006", name: "Presidential Suite", max_occupancy: 4, saved_mapping: null },
];

export const OUR_ROOM_TYPES = [
  { id: 1, name: "Standard", base_rate: 2000 },
  { id: 2, name: "Deluxe",   base_rate: 3500 },
  { id: 3, name: "Suite",    base_rate: 6000 },
];

// Rate plans pushed by 3rd-party PMS via /setup call
// default_channel is what the vendor suggests — manager can override
export const EXTERNAL_RATE_PLANS_MOCK = [
  { code: "BAR",        name: "Best Available Rate",       default_channel: "PMS", saved_channel: null, saved_commission: null },
  { code: "DIRECT_WEB", name: "Website Direct Rate",       default_channel: "BE",  saved_channel: null, saved_commission: null },
  { code: "MMT_STD",    name: "MakeMyTrip Standard",       default_channel: "OTA", saved_channel: null, saved_commission: null },
  { code: "MMT_CORP",   name: "MakeMyTrip Corporate",      default_channel: "OTA", saved_channel: null, saved_commission: null },
  { code: "BKG_STD",    name: "Booking.com Standard",      default_channel: "OTA", saved_channel: null, saved_commission: null },
  { code: "CORP_TCS",   name: "TCS Corporate Rate",        default_channel: "PMS", saved_channel: null, saved_commission: null },
  { code: "CORP_GOVT",  name: "Government Rate",           default_channel: "PMS", saved_channel: null, saved_commission: null },
  { code: "PKG_BB",     name: "Bed & Breakfast Package",   default_channel: "BE",  saved_channel: null, saved_commission: null },
];

// Default commissions per channel — used as fallback when rate plan has no override
export const DEFAULT_COMMISSIONS = { PMS: 0, BE: 0, OTA: 15 };

// ── Helpers ───────────────────────────────────────────────────
export const fmt = (n) => `₹${Number(n).toLocaleString("en-IN")}`;
export const pct = (b, r) => (((r - b) / b) * 100).toFixed(1);

export const STATUS_CFG = {
  PENDING:  { color: "#b45309", bg: "#fffbeb", border: "#fde68a" },
  APPROVED: { color: "#15803d", bg: "#f0fdf4", border: "#86efac" },
  MODIFIED: { color: "#1d4ed8", bg: "#eff6ff", border: "#93c5fd" },
  REJECTED: { color: "#b91c1c", bg: "#fef2f2", border: "#fca5a5" },
};

export const SOURCE_CFG = {
  PMS: { color: "#6d28d9", bg: "#f5f3ff", border: "#c4b5fd", label: "PMS"            },
  BE:  { color: "#0369a1", bg: "#e0f2fe", border: "#7dd3fc", label: "Booking Engine"  },
  OTA: { color: "#be185d", bg: "#fdf2f8", border: "#f9a8d4", label: "OTA"             },
};
